/* this file is transformed by vux-loader */
/* eslint-disable */
require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.regexp.test.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.regexp.constructor.js");

require("core-js/modules/es.regexp.dot-all.js");

require("core-js/modules/es.regexp.sticky.js");

require("core-js/modules/es.regexp.to-string.js");

/**
 * @describe 将时间戳转为字符串日期
 * @use "/Date(1608272210000)/".JsonFormat('yyyy-MM-dd hh:mm:ss')
 * @result 2020-12-18 14:20:15
 */
String.prototype.JsonFormat = function (fmt) {
  return this.ToDate().Format(fmt ? fmt : 'yyyy-MM-dd');
};
/**
 * @describe 将中国标准时间转为字符串日期
 * @param fmt(yyyy-MM-dd hh:mm:ss)
 * @use new Date().Format("yyyy-MM-dd hh:mm:ss")
 * @use new Date().Format("yyyy年MM月dd日 hh:mm:ss")
 * @result 2020-02-20 21:39:35
 */


Date.prototype.Format = function () {
  var fmt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'yyyy-MM-dd';
  var o = {
    "M+": this.getMonth() + 1,
    //月
    "d+": this.getDate(),
    //日
    "h+": this.getHours(),
    //时
    "m+": this.getMinutes(),
    //分
    "s+": this.getSeconds(),
    //秒
    "S": this.getMilliseconds(),
    //毫秒
    "q+": Math.floor((this.getMonth() + 3) / 3) //季度

  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));

  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
  }

  return fmt;
};
/**
 * @describe 将时间戳转为中国标准时间
 * @use "/Date(1608272210000)/".ToDate()
 * @result Mon Jan 18 2021 14:16:50 GMT+0800 (中国标准时间)
 */


String.prototype.ToDate = function () {
  var jsondate = this;
  jsondate = jsondate.replace("/Date(", "").replace(")/", "");

  if (jsondate.indexOf("+") > 0) {
    jsondate = jsondate.substring(0, jsondate.indexOf("+"));
  } else if (jsondate.indexOf("-") > 0) {
    jsondate = jsondate.substring(0, jsondate.indexOf("-"));
  }

  return new Date(parseInt(jsondate, 10));
};
/**
 * @describe 获取星期几
 * @use new Date().DateWeekFormat()
 * @result 星期二
 */


Date.prototype.DateWeekFormat = function () {
  // getDay() 返回表示星期的某一天的数字
  // 注:0-6对应为星期日到星期六
  var myday = this.getDay();
  var w = ['日', '一', '二', '三', '四', '五', '六'];
  return '星期' + w[myday];
};